module.exports = __webpack_public_path__ + "static/media/image_87.6a26137d.png";